export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path.startsWith('/osocial/') && to.path !== '/osocial/feed') {
    return navigateTo('/osocial/feed', { redirectCode: 302 });
  }

  return true;
});
